import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

export default class extends Controller {
  static targets = ['input']

  static values = {
    pickerOptions: Object,
  }

  pickerOptions = {
    onChange: this.pickerOnChange,
  }

  get filterId() {
    return this.filterContainer.dataset.filterId
  }

  get filterContainer() {
    return this.context.element.closest('[data-filter-param-id]')
  }

  get conditionTarget() {
    return this.filterContainer?.querySelector("[data-control='condition'")
  }

  get pickerModeFromCondition() {
    return this.conditionTarget.value === 'is_within' ? 'range' : 'single'
  }

  connect() {
    this.initFlatpickr()
  }

  initFlatpickr(extraOptions = {}) {
    const options = {
      mode: this.pickerModeFromCondition,
    }

    const allOptions = { ...options, ...this.pickerOptionsValue, ...extraOptions }

    this.pickerInstance = flatpickr(this.inputTarget, allOptions)
  }

  destroyFlatpickr() {
    if (this.pickerInstance) {
      this.pickerInstance.destroy()
    }
  }

  reloadFlatpickr(extraOptions) {
    this.destroyFlatpickr()
    this.initFlatpickr(extraOptions)
  }

  onConditionChange() {
    this.reloadFlatpickr()
  }

  closePicker() {
    if (this.pickerInstance.isOpen) {
      setTimeout(() => {
        this.pickerInstance.close()
      }, 1)
    }
  }
}
